import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import site from './modules/site';
import login from './modules/login';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';

export default new Vuex.Store({
  modules: {
    site,
    login,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js